import { CoffeeShop } from './types';
import { formatAddress, getGoogleMapsUrl, getAppleMapsUrl } from './mapLinks';

interface CoffeeShopModalProps {
  shop: CoffeeShop;
  onClose: () => void;
}

export default function CoffeeShopModal({ shop, onClose }: CoffeeShopModalProps) {
  return (
    <div className="ct-modal-overlay" onClick={onClose}>
      <div
        className="ct-modal"
        role="dialog"
        aria-modal="true"
        aria-label={shop.name}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="ct-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <img className="ct-modal-image" src={shop.imageUrl} alt={shop.name} />

        <div className="ct-modal-body">
          <h2>{shop.name}</h2>
          <p className="ct-modal-blurb">{shop.blurb}</p>

          <div className="ct-modal-section">
            <h3>Try These</h3>
            <ul className="ct-drink-list">
              {shop.specialtyDrinks.map((drink) => (
                <li key={drink}>{drink}</li>
              ))}
            </ul>
          </div>

          <div className="ct-modal-section">
            <h3>{shop.addresses.length > 1 ? 'Locations' : 'Location'}</h3>
            {shop.addresses.map((address) => (
              <div className="ct-address-block" key={`${address.label}-${address.street}`}>
                {shop.addresses.length > 1 && (
                  <p className="ct-address-label">{address.label}</p>
                )}
                <p className="ct-address-text">{formatAddress(address)}</p>
                <div className="ct-map-buttons">
                  <a
                    href={getGoogleMapsUrl(address)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ct-map-btn"
                  >
                    Open in Google Maps
                  </a>
                  <a
                    href={getAppleMapsUrl(address)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ct-map-btn"
                  >
                    Open in Apple Maps
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
